import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyCIp7ifga2gmYPnzfZEciA99T9KUtagCv8",
    authDomain: "evoaxy-37d0e.firebaseapp.com",
    projectId: "evoaxy-37d0e",
    storageBucket: "evoaxy-37d0e.firebasestorage.app",
    messagingSenderId: "187452945838",
    appId: "1:187452945838:web:679eb389716f157c39c43f",
    measurementId: "G-8S97YENW00"
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)

